"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.readCircle = readCircle;
const Util_1 = require("../../Util");
const v6Common_1 = require("./v6Common");
function readCircle(node, defaultLayerName = '') {
    let x = 0, y = 0;
    let endX = 0, endY = 0;
    let layer = defaultLayerName;
    let width = 0;
    let filled = false;
    let radius;
    let lineStyle;
    node.nodes.forEach((n) => {
        switch (n.name) {
            case 'center': {
                x = parseFloat(n.values[0]);
                y = parseFloat(n.values[1]);
                break;
            }
            case 'end': {
                endX = parseFloat(n.values[0]);
                endY = parseFloat(n.values[1]);
                break;
            }
            case 'layer': {
                layer = (0, Util_1.removeQuotes)(n.values[0]);
                break;
            }
            case 'width': {
                width = parseFloat(n.values[0]);
                break;
            }
            case 'radius': {
                radius = parseFloat(n.values[0]);
                break;
            }
            case 'stroke': {
                const stroke = (0, v6Common_1.parseStrokeDirective)(n);
                width = stroke.width;
                lineStyle = stroke.type;
                break;
            }
            case 'fill': {
                if (n.nodes.length > 0) {
                    const typeNode = n.nodes.find((v) => v.name === 'type');
                    if (typeNode) {
                        filled = n.values[0] === 'solid';
                    }
                }
                else {
                    filled = n.values[0] === 'solid';
                }
                break;
            }
        }
    });
    const circle = {
        type: 'circle',
        center: [x, y],
        radius: typeof radius === 'number' ? radius : Math.hypot(endX - x, endY - y),
        filled: filled ? 1 : undefined,
        width,
        metadata: {
            lineStyle,
        },
    };
    return { layer, circle };
}
//# sourceMappingURL=v6ParseCircle.js.map